(<template>
  <banner :message="bannerMessage"
          class="hospital-info-banner" />
</template>)

<script>
  import Banner from '@/components/shared_components/banners/Banner';

  export default {
    components: {
      banner: Banner
    },
    computed: {
      bannerMessage() {
        return this.$gettext('To find the correct department, please search for the Resh number under the "Department" tab in the order form.');
      }
    },
  };
</script>

<style scoped>
  .hospital-info-banner {
    width: calc(100% - 30px);
    margin: 15px auto 0;
  }

  @media (max-width: 767px) {
    .hospital-info-banner {
      width: 100%;
    }
  }
</style>
